module.exports = __webpack_public_path__ + "static/img/kr-lottery.e8e42daf.png";